import {connect} from "react-redux";
import PackingList from "../components/PackingList";
import {getSortedPackingUberDirect} from "../selectors/packing";


const SHOW_OBJECT = {prep: true};

const mapStateToProps = state => {
  let tasks = getSortedPackingUberDirect(state);

  return { tasks: tasks, title: "Commande en attente de pickup par Uber Direct", className: 'to-check-list', show: SHOW_OBJECT};
};

const mapDispatchToProps = dispatch => {
  return {
    // "onDropTask": (targetTaskId, droppedTaskId) => dispatch(dropOnPackingTask(targetTaskId, droppedTaskId)),
    // "onDropDefault": (driverId, droppedTaskId) => dispatch(dropOnPackingDefault(droppedTaskId)),
  };
};

let PackingUberDirectListLinked = connect(
  mapStateToProps,
  mapDispatchToProps
)(PackingList);

export default PackingUberDirectListLinked;
